<router-outlet></router-outlet>
<tec-cookie-consent></tec-cookie-consent>